import { ArrowIcon } from "~/shared/components/icons/ArrowIcon";
import { SpinnerIcon } from "~/shared/components/icons/SpinnerIcon";
import { tw } from "~/utils";

interface ConfirmActionButtonsProps {
  onConfirm?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  helperText?: string;
  selectedSummary?: string;
  className?: string;
}

export const ConfirmActionButtons = ({
  onConfirm,
  disabled = false,
  isLoading = false,
  helperText,
  selectedSummary,
  className,
}: ConfirmActionButtonsProps) => {
  return (
    <div className={tw("flex w-full items-center justify-between", className)}>
      {/* Helper text (nothing selected) / selection summary (ready to confirm) */}
      <div className="flex-1 px-4">
        {disabled && helperText && (
          <span className="text-xs text-gray-500">{helperText}</span>
        )}
        {!disabled && selectedSummary && (
          <span className="text-xs font-medium text-gray-700">
            {selectedSummary}
          </span>
        )}
      </div>

      {/* Confirm button on right */}
      {onConfirm && (
        <button
          type="button"
          onClick={onConfirm}
          disabled={disabled || isLoading}
          className={tw(
            "flex cursor-pointer items-center gap-2 bg-green-300 px-6 py-4 font-medium",
            (disabled || isLoading) &&
              "cursor-not-allowed bg-gray-300 opacity-50",
          )}
        >
          {isLoading ? (
            <SpinnerIcon className="h-5 w-5" />
          ) : (
            <>
              <span>CONFIRM</span>
              <ArrowIcon direction="left" />
            </>
          )}
        </button>
      )}
    </div>
  );
};
